/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


window.Vue = require('vue').default;
import {
    applyPolyfills,
    defineCustomElements,
} from 'img-comparison-slider/loader';
import Lang from 'lang.js';
import VueRouter from "vue-router";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import routes from './router';
import store from './store';
import './aos';
import LoadScript from 'vue-plugin-load-script';
import vSelect from 'vue-select'

window.store = store;

// Currency filter plugin
require('./plugins/currency');
// Rica Vue Stepper
import './vue-stepper';

Vue.config.productionTip = false;
Vue.config.ignoredElements = ["img-comparison-slider", /test-\w*/];

// Bind the custom elements to the window object (img-comparison-slider/loader)
applyPolyfills().then(() => {
    defineCustomElements(window);
});

Vue.use(LoadScript);
Vue.use(VueToast, {
    position: 'bottom',
    pauseOnHover: false,
});

Vue.component('v-select', vSelect)
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('header-component', require('./components/layouts/header.vue').default);
Vue.component('footer-component', require('./components/layouts/footer.vue').default);
Vue.component('mini-footer', require('./components/layouts/miniFooter.vue').default);
Vue.component('scrollable-section', require('./components/common/scrollable/ScrollableSection.vue').default);
Vue.component('parallax-rounded-image', require('./components/common/parallax/ParallaxRoundedImage.vue').default);
Vue.component('product-card', require('./components/cards/ProductCard.vue').default);
Vue.component('slider-cover', require('./components/SliderCover.vue').default);
Vue.component('floating-input', require('./components/common/forms/FloatingInput.vue').default);
Vue.component('floating-select', require('./components/common/forms/FloatingSelect.vue').default);
Vue.component('floating-textarea', require('./components/common/forms/FloatingTextarea.vue').default);
Vue.component('add-item', require('./components/product/AddItem.vue').default);
Vue.component('shop-component', require('./components/shop/Shop.vue').default);
Vue.component('button-slider', require('./auth/ButtonSlider.vue').default);
Vue.component('faqs-index', require('./components/faqs/FaqsIndex.vue').default);
Vue.component('cart-component', require('./components/cart/Cart.vue').default);
Vue.component('cart-resume', require('./components/cart/CartResume.vue').default);
Vue.component('wizard-base', require('./components/wizard/WizardBase.vue').default);
Vue.component('stepper-wrapper', require('./components/wizard/steps/StepperWrapper.vue').default);
Vue.component('component-data', require('./components/wizard/common/ComponentData.vue').default);
Vue.component('btn-primary', require('./components/common/buttons/BtnPrimary.vue').default);
Vue.component('address-form', require('./components/wizard/common/AddressForm.vue').default);
Vue.component('shop-map', require('./components/ShopMap.vue').default);

const messages = Object.entries(window.messages[window.appLocale]).reduce((agg, [key, value]) => {
    agg[`${window.appLocale}.${key}`] = value;
    return agg;
}, {});
Vue.prototype.trans = new Lang({
    messages,
    locale: window.appLocale,
});

Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history',
    base: window.appLocale,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
});
window.router = router;


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

export const eventBus = new Vue();

const app = new Vue({
    el: '#app',
    router,
    store
});
window.app = app;

// Protect image download
const images = document.querySelectorAll('img');
images.forEach((img) => {
    img.oncontextmenu = (e) => e.preventDefault();
});
